function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Controller } from 'stimulus';
export default class _class extends Controller {
  add(e) {
    e.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.targetTarget.insertAdjacentHTML('beforebegin', content);
  }

}

_defineProperty(_class, "targets", ['target', 'template']);